import {
  requestGet,
  requestPost,
  requestPut,
  requestPostFileBlob,
} from "../config/Api";

const base = "unlinked/lawsuits";

export const getUnlinkedLawsuits = (params) => requestGet(base, { params });

export const getUnlinkedLawsuitById = (id) => requestGet(`${base}/${id}`);

export const updateUnlinkedLawsuit = (id, payload) =>
  requestPut(`${base}/${id}`, payload);

export const downloadUnlinkedLawsuit = (id) =>
  requestPostFileBlob(`${base}/${id}/download`);

export const completeUnlinkedLawsuit = (id) =>
  requestPost(`${base}/${id}/complete`);

export const discardUnlinkedLawsuit = (id) =>
  requestPost(`${base}/${id}/discard`);
